import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import 'react-datepicker/dist/react-datepicker.css';
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { isShowUserPopup, setShowUserPopup, showMessage } from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';
import CheckBox from '../../widgets/CheckBox';
import DateInput from '../../widgets/DateInput';


export function WriterQuestionnaire() {
    const [state, setState] = useState({writer:null, errors:{}, showImagePicker:false});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);
    const showUserPopup = useSelector(isShowUserPopup);

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getWriter();
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getWriter = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/user/`, config);
            showLoading(dispatch, false);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(reply.data.avatar && reply.data.avatar.length === 1) {
                    reply.data.avatar = reply.data.avatar[0];
                }

                setState({
                    ...state,
                    writer: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            if(e?.response?.data?.hasOwnProperty("errors")){
                errorMessage = e.response.data["errors"];
            }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            showLoading(dispatch, true);
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};


            //value.toString().slice(0, 10),
          
            const data = {"isManuscriptFinished" : state.writer.isManuscriptFinished, "numberOfWords" : state.writer.numberOfWords, "genre" : state.writer.genre, "isManuscriptCompleteBetaReading" : state.writer.isManuscriptCompleteBetaReading, "timeReadByNumberBetaReaders" : state.writer.timeReadByNumberBetaReaders, "publishingQuiz" : state.writer.publishingQuiz, "isDeadline" : state.writer.isDeadline, "deadlineDate" : state.writer.deadlineDate, "yourExpectations" : state.writer.yourExpectations, "additionalComments" : state.writer.additionalComments};

            try {
                const reply = await axios.patch(API_URL + '/user', data, config);
                showLoading(dispatch, false);
                if(reply.hasOwnProperty('status') && reply.status === API_204) {
                    if(showUserPopup) {
                        navigateTo(dispatch, navigate, "/verify-email");
                    } else {
                        navigateTo(dispatch, navigate, "/writer-profile");
                    }
                }
            } catch (e) {
                showLoading(dispatch, false);
                if(e?.response?.data?.hasOwnProperty("errors")){
                    errorMessage = e.response.data["errors"];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };


    const handleNumberChange = (e) => {
        change(e.target.id, e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'));
    };

    const handleChange = (e) => {
        change(e.target.id, e.target.value);
    };

    const change = (id, value) => {
        delete state.errors[id];
        setState({
            ...state, 
            writer:{...state.writer,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const changeList = (listName, id) => {
        let list = state.writer[listName]?? {};
        if(list && list[id]) {
            delete list[id];
        } else {
            list = {...list, [id]: id};
        }
        change(listName, list);
        //return list;
    };

    const changeGenre = (id) => {
        changeList('genre', id);
    };

    const changePublishingQuiz = (id) => {
        changeList('publishingQuiz', id);
    };

    const validateForm = () => {
        const errors = {};

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };

    return (
        <Frame showMenu={!showUserPopup} showNav={!showUserPopup}>
            <div className='main main-writer-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.writer?<Background showClouds={showUserPopup}>
                            <div className='right-main-inner'>
                                <div className='text-align-center font-19 mt10'>{t('to_improve_user_experience')}</div>

                                <div className='mt40 flex justify-content-space-between align-items-center ml5 mr5'>
                                    <div className='font-18'><Trans i18nKey={'is_manuscript_finished'}/></div>
                                    <div className='font-15 color-gray flex align-items-center ml5 mr5'>
                                        <div className='ml5'><CheckBox id={true} text={t('yes')} textInside={true} value={state.writer.isManuscriptFinished} onChange={(id) => change('isManuscriptFinished', id)} /></div>
                                        <CheckBox id={false} text={t('no')} textInside={true} value={state.writer.isManuscriptFinished} onChange={(id) => change('isManuscriptFinished', id)} />
                                    </div>
                                </div>

                                <div className='mt40'>
                                    <Input className={state.errors.numberOfWords?"error":""} id="numberOfWords" placeholder={t("number_of_words")} value={''+(state.writer.numberOfWords??'')} onChange={(e) => handleNumberChange(e)}/>
                                </div>

                                <div className='mt40 flex justify-content-space-between align-items-center ml5 mr5'>
                                    <div className='text-align-center font-25 mt10'>{t('genre')}</div>
                                    <div className='text-align-center font-15 mt10'>{t('select_options')}</div>
                                </div>



                                <div className='mt10 font-15 flex'>
                                    <div className='font-15 flex flex-direction-column width-50'>
                                        <div className='mt10'><CheckBox id='horror' text={t('horror')} value={state.writer.genre?.horror} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='scifi' text={t('scifi')} value={state.writer.genre?.scifi} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='young_adult_literature' text={t('young_adult_literature')} value={state.writer.genre?.young_adult_literature} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='prose' text={t('prose')} value={state.writer.genre?.prose} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='romantics' text={t('romantics')} value={state.writer.genre?.romantics} onChange={(id) => changeGenre(id)} /></div>
                                    </div>

                                    <div className='font-15 flex flex-direction-column width-50'>
                                        <div className='mt10'><CheckBox id='adventure' text={t('adventure')} value={state.writer.genre?.adventure} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='thriller' text={t('thriller')} value={state.writer.genre?.thriller} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='fantasy' text={t('fantasy')} value={state.writer.genre?.fantasy} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='historical_fiction' text={t('historical_fiction')} value={state.writer.genre?.historical_fiction} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='poetry' text={t('poetry')} value={state.writer.genre?.poetry} onChange={(id) => changeGenre(id)} /></div>
                                        <div className='mt10'><CheckBox id='other' text={t('other')} value={state.writer.genre?.other} onChange={(id) => changeGenre(id)} /></div>
                                    </div>
                                </div>

                                <div className='mt30 font-18 center-div'><Trans i18nKey={'is_manuscript_complete_beta_reading'}/></div>

                                <div className='mt20 flex justify-content-space-between align-items-center ml5 mr5'>
                                    <div className='font-15 color-gray flex align-items-center ml5 mr5'>
                                        <div className='ml5'><CheckBox id={true} text={t('yes')} textInside={true} value={state.writer.isManuscriptCompleteBetaReading} onChange={(id) => change('isManuscriptCompleteBetaReading', id)} /></div>
                                        <CheckBox id={false} text={t('no')} textInside={true} value={state.writer.isManuscriptCompleteBetaReading} onChange={(id) => change('isManuscriptCompleteBetaReading', id)} />
                                    </div>
                                    <div className='font-18'><Trans i18nKey={'if_yes_please_fill'}/></div>
                                </div>

                                <div className='mt20'>
                                    <Input className={state.errors.timeReadByNumberBetaReaders?"error":""} id="timeReadByNumberBetaReaders" placeholder={t("time_read_by_number_beta_readers")} value={''+(state.writer.timeReadByNumberBetaReaders??'')} onChange={(e) => handleNumberChange(e)}/>
                                </div>

                                <div className='flex justify-content-space-between align-items-center ml5 mr5'>
                                    <div className='text-align-center font-12 mt10'>{t('time_read_by_number_beta_readers_explanation')}</div>
                                </div>


                                <div className='text-align-center font-18 mt40'><Trans i18nKey={'publishing_steps_focus_on'}/></div>
                                <div className='mt10 flex justify-content-end align-items-center ml5 mr5'>
                                    <div className='text-align-center font-15 mt10'>{t('select_options')}</div>
                                </div>



                                <div className='mt10 font-15 flex'>
                                    <div className='font-15 flex flex-direction-column width-50'>
                                        <div className='mt10'><CheckBox id='content_editing' text={t('content_editing')} value={state.writer.publishingQuiz?.content_editing} onChange={(id) => changePublishingQuiz(id)} /></div>
                                        <div className='mt10'><CheckBox id='typesetting' text={t('typesetting')} value={state.writer.publishingQuiz?.typesetting} onChange={(id) => changePublishingQuiz(id)} /></div>
                                        <div className='mt10'><CheckBox id='proofreading' text={t('proofreading')} value={state.writer.publishingQuiz?.proofreading} onChange={(id) => changePublishingQuiz(id)} /></div>
                                        <div className='mt10'><CheckBox id='marketing_content_creation' text={t('marketing_content_creation')} value={state.writer.publishingQuiz?.marketing_content_creation} onChange={(id) => changePublishingQuiz(id)} /></div>
                                      </div>

                                    <div className='font-15 flex flex-direction-column width-50'>
                                        <div className='mt10'><CheckBox id='technical_editing' text={t('technical_editing')} value={state.writer.publishingQuiz?.technical_editing} onChange={(id) => changePublishingQuiz(id)} /></div>
                                        <div className='mt10'><CheckBox id='cover_design' text={t('cover_design')} value={state.writer.publishingQuiz?.cover_design} onChange={(id) => changePublishingQuiz(id)} /></div>
                                        <div className='mt10'><CheckBox id='printing_houses' text={t('printing_houses')} value={state.writer.publishingQuiz?.printing_houses} onChange={(id) => changePublishingQuiz(id)} /></div>
                                        <div className='mt10'><CheckBox id='branding' text={t('branding')} value={state.writer.publishingQuiz?.branding} onChange={(id) => changePublishingQuiz(id)} /></div>
                                        <div className='mt10'><CheckBox id='other' text={t('other')} value={state.writer.publishingQuiz?.other} onChange={(id) => changePublishingQuiz(id)} /></div>
                                    </div>
                                </div>

                                <div className='mt40 flex justify-content-space-between align-items-center ml5 mr5'>
                                    <div className='font-18'><Trans i18nKey={'have_deadline'}/></div>
                                    <div className='font-15 color-gray flex align-items-center ml5 mr5'>
                                        <div className='ml5'><CheckBox id={true} text={t('yes')} textInside={true} value={state.writer.isDeadline} onChange={(id) => change('isDeadline', id)} /></div>
                                        <CheckBox id={false} text={t('no')} textInside={true} value={state.writer.isDeadline} onChange={(id) => change('isDeadline', id)} />
                                    </div>
                                </div>

                                {state.writer.isDeadline && <div className='mt25'>
                                    <DateInput id="deadlineDate" placeholder={t("deadline_date")} value={state.writer.deadlineDate} readOnly={true} onChange={(date) => change('deadlineDate', date)} />
                                </div>}

                                <div className='mt30'>
                                    <Input className={state.errors.yourExpectations?"error":""} id="yourExpectations" placeholder={t("your_expectations")} value={state.writer.yourExpectations??''} onChange={(e) => handleChange(e)}/>
                                </div>

                                <div className='mt30'>
                                    <Input className={state.errors.additionalComments?"error":""} id="additionalComments" placeholder={t("additional_comments")} value={state.writer.additionalComments??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                

                                <div className='button mt30 mb40' onClick={(e) => handleSubmit(e)}>  <div>{t("next")}</div> </div>
                            </div>
                        </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}